module.exports = __webpack_public_path__ + "images/619d4b90c13574b993acd3c364dc88cc.png";